var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 23.188 23.188",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.203 19.08 8.9166-16.559c0.1434-0.26616 0.3562-0.48854 0.6158-0.64354s0.5563-0.23684 0.8586-0.23684c0.3024 0 0.5991 0.08184 0.8586 0.23684 0.2596 0.155 0.4724 0.37738 0.6158 0.64354l8.9166 16.559c0.1371 0.2551 0.2058 0.5414 0.1992 0.831-0.0065 0.2895-0.0881 0.5724-0.2366 0.821-0.1486 0.2487-0.359 0.4545-0.6109 0.5975s-0.5365 0.2182-0.8261 0.2184h-17.833c-0.28962-2e-4 -0.57426-0.0754-0.82612-0.2184-0.25186-0.143-0.46234-0.3488-0.61088-0.5975-0.14854-0.2486-0.23007-0.5315-0.23663-0.821-0.00655-0.2896 0.06209-0.5759 0.19922-0.831z",
    stroke: "#ef4d2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.0067
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.594 18.524c0.7906 0 1.4315-0.6409 1.4315-1.4314 0-0.7906-0.6409-1.4315-1.4315-1.4315s-1.4314 0.6409-1.4314 1.4315c0 0.7905 0.6408 1.4314 1.4314 1.4314z",
    fill: "#ef4d2a",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.594 7.2331v5.1573",
    stroke: "#ef4d2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.0067
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDanger);
export default __webpack_public_path__ + "static/media/warning_danger.3c62e56df5598706a9d317756193805e.svg";
export { ForwardRef as ReactComponent };